import { Component, Input, OnInit } from '@angular/core';
import { GenericSmartList } from '@components/smart-list/GenericSmartList';
import { VendorModel } from '@shared/models/VendorModel';

@Component({
    selector: 'app-smart-list-community-vendor',
    templateUrl: './smart-list-community-vendor.component.html',
    styleUrls: ['./smart-list-community-vendor.component.scss']
})
export class SmartListCommunityVendorComponent extends GenericSmartList<VendorModel> implements OnInit {

    @Input() vendors: VendorModel[] = [];

    showAllStores = false;

    constructor() { 
        super();
    }

    ngOnInit() {

        this.source = this.vendors?.filter(x => x.name);
    }

    validAllStore() {
        
        this.showAllStores = !this.showAllStores;
    }
}
